//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import UnclaimReassignModal from "@/components/tasks/unclaimReassign/unclaimReassignModal.vue";
import { required } from "vuelidate/lib/validators";

export default {
    name: "FabFooterMenu",
    components: { UnclaimReassignModal, AQButton, AQMenu, AQDialog, AQInput, AQRadio },
    props: {
        value: { type: Boolean },
        readOnly: { type: Boolean },
        isExternal: { type: Boolean },
        canUnclaim: { type: Boolean },
        canReassign: { type: Boolean },
        canEscalate: { type: Boolean },
        taskId: { type: String, default: "" },
        isCompletedTask: { type: Boolean },
        taskExternalReports: { type: Boolean },
        externalPhone: { type: Boolean },
        fromAdmin: { type: Boolean },
        reassignUserList: { type: String, default: "" },
        activityId: { type: String, default: "" },
        isManager: {
            type: Boolean,
            default: false
        },
        invalidInputData: {
            type: Boolean,
            default: false
        },
        actionsList: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            openModal: false,
            reassignAction: false,
            showMenu: [],
            showDialog: false,
            targetList: "",
            showCommentArea: false,
            requiredComment: false,
            radioError: false,
            commentText: null,
            connectors: []
        };
    },
    validations: {
        commentText: {
            required(v) {
                if (!this.requiredComment) {
                    return true;
                }
                return required(v);
            }
        }
    },
    computed: {
        ...mapState("components", ["isSmallScreen"]),
        ...mapState("userProfile", ["userEmail"]),
        ...mapGetters("diagrams", ["diagramConfigData", "diagramData"]),
        ...mapGetters("components", ["getFilteredOutcomes"]),
        menuOptions() {
            const options = [];
            if (this.canUnclaim) {
                options.push({ label: this.$t("fabricInterface.unclaim") });
            }
            if (this.canReassign && this.readOnly) {
                options.push({ label: this.$t("fabricInterface.reassign") });
            }
            if (this.canEscalate) {
                options.push({ label: this.$t("fabricInterface.escalate") });
            }
            return options;
        },
        getConnectorsList() {
            let filteredList = [];
            if (this.getFilteredOutcomes.length) {
                filteredList = this.actionsList.filter(el => this.getFilteredOutcomes.find(obj => el.value === obj.actionId));
            }
            return filteredList.length ? filteredList : this.actionsList;
        },
        getConnectorsNumber() {
            return this.getConnectorsList.length > 1;
        },
        showConfirmInfo() {
            return this.isSmallScreen ? "" : this.$t("fabricInterface.confirmInfo");
        },
        confirmButtonText() {
            return this.isSmallScreen ? this.$t("fabricInterface.confirmBtnMobile") : this.$t("fabricInterface.confirmBtn");
        },
        commentType() {
            let msg = "";
            if (this.requiredComment && this.showCommentArea && !this.$v.commentText.$error) {
                msg = this.$t("fabricInterface.mandatoryComment");
            } else if (!this.requiredComment && this.showCommentArea && !this.$v.commentText.$error) {
                msg = this.$t("fabricInterface.optionalComment");
            }
            return msg;
        }
    },
    methods: {
        onClickSave() {
            this.$emit("action", "save");
        },
        onClickSubmit() {
            if (this.getConnectorsList && (this.getConnectorsList[0].preselectedTarget
            || (this.getConnectorsList.length === 1 && this.getFilteredOutcomes.length))) {
                this.targetList = this.getConnectorsList[0].value;
            }
            this.checkSubmissionOptions();
            this.showDialog = true;
            this.$emit("action", "submit");
        },
        onClickCancel(ev) {
            this.$emit("action", { trigger: "cancel", ev });
        },
        openDlg(event) {
            const actionType = event[0].label ? event[0].label.trim() : "";
            if (actionType === this.$t("fabricInterface.unclaim")) {
                this.reassignAction = false;
            } else if (actionType === this.$t("fabricInterface.reassign")) {
                this.reassignAction = true;
            }
            // this.$refs["popover_" + id].hide();
            this.openModal = true;
        },
        modalClosed() {
            this.openModal = false;
        },
        unclaimMessageEvent() {
            this.$emit("showUnclaimMsg");
        },
        reassignMessageEvent() {
            this.$emit("showReassignMsg");
        },
        locationReplaceEvent() {
            this.$emit("locationReplace");
        },
        checkSubmissionOptions() {
            this.showCommentArea = false;
            this.requiredComment = false;
            this.radioError = false;
            this.commentText = null;
            this.$v.$reset();
            if (this.getConnectorsList.length > 1) {
                const elem = this.getConnectorsList.find(element => element.value === this.targetList) || {};
                if ((!elem.submissionOption || elem.submissionOption === "OPTIONAL") && this.targetList) {
                    this.showCommentArea = true;
                }
                if (elem.submissionOption === "REQUIRED") {
                    this.showCommentArea = true;
                    this.requiredComment = true;
                }
            } else if (this.getConnectorsList.length === 1) {
                if (!this.getConnectorsList[0].submissionOption || this.getConnectorsList[0].submissionOption === "OPTIONAL") {
                    this.showCommentArea = true;
                }
                if (this.getConnectorsList[0].submissionOption === "REQUIRED") {
                    this.requiredComment = true;
                    this.showCommentArea = true;
                }
            }
        },
        commentValidation() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.showDialog = true;
                return false;
            }
            if (this.getConnectorsList && this.getConnectorsList.length > 1) {
                if (!this.targetList) {
                    this.radioError = true;
                    this.showDialog = true;
                    return false;
                }
            }
            this.$emit("taskSubmissionComment", this.targetList, this.commentText);
            return true;
        },
        closeDialog() {
            this.targetList = "";
            this.radioError = false;
            this.$v.$reset();
        }
    }
};
